export function isNativeStandby() {
  if (window.__CS_STANDBY__ === true) return true;
  try {
    return JSON.parse(window.ReactNativeWebView?.injectedObjectJson?.() || '{}')?.citizenScienceStandby === true;
  } catch (_) { return false; }
}

export function parseNativeVisibility(raw, nonce) {
  try {
    if (typeof raw !== 'string' || raw.length > 1000) return null;
    const value = JSON.parse(raw);
    return value?.version === 1 && value.type === 'cs-visibility' && value.nonce === nonce &&
      typeof value.active === 'boolean' ? value : null;
  } catch (_) { return null; }
}

export function parseNativeSession(raw, nonce) {
  try {
    if (typeof raw !== 'string' || raw.length > 18000) return null;
    const value = JSON.parse(raw);
    if (value.version !== 1 || value.type !== 'cs-session' || value.nonce !== nonce ||
        typeof value.customToken !== 'string' || value.customToken.length < 20 ||
        typeof value.reviewerUid !== 'string' || !/^ls_[a-f0-9]{64}$/.test(value.reviewerUid)) return null;
    return value;
  } catch (_) { return null; }
}

export function postNative(type, nonce, data = {}) {
  window.ReactNativeWebView?.postMessage(JSON.stringify({...data, version: 1, type, nonce}));
}
